
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/rEditor/rootComps/siteCreation/horizontalLoader.scss.css.virtualfile';
        module.exports = {"siteCreationHorizontalLoader":"_siteCreationHorizontalLoader_s7gr5_1"};